module.exports = __webpack_public_path__ + "static/img/logo.5f2a98af.png";